import React, { Component } from "react";
import DragSortableList from "../../../../../CC_cubi_clan_project/GlobalComponents/DragSortableList/DragSortableList";
import { getStableKey, resolveParentIndex } from "../../../../../CC_cubi_clan_project/GlobalComponents/DragSortableList/dndUtils";
import { mfmOriginalUrl } from "../../../../../CC_cubi_clan_project/Utils/MfmService";
import TeaserVideoPlayer from "../../Common/TeaserVideoPlayer";
import "./VideosSection.css";

/**
 * Props:
 *  - videos: [{ idVideo?, title?, description?, src?, fileUrl?, url?, externalId?, sortOrder? }]
 *  - onEdit(index, item)       // índice REAL en el array del padre
 *  - onCreate()
 *  - onChange(updatedArray)    // DragSortableList devuelve array reindexado (sortOrder = i+1)
 */

// Extractores de ID (prioridad): idVideo -> externalId
const videoId = (v) => v?.idVideo;
const extId   = (v) => v?.externalId;
// Fallback para nuevos sin ID (por URL que tengamos)
const fallback = (a, b) => {
  const au = a?.src || a?.fileUrl || a?.url || "";
  const bu = b?.src || b?.fileUrl || b?.url || "";
  return !a?.idVideo && au === bu;
};

export default class VideosSection extends Component {
  static defaultProps = { videos: [] };

  handleReorder = (updated) => {
    this.props.onChange && this.props.onChange(updated);
  };

  handleEditClick = (visibleIndex, video) => {
    const parentArr = this.props.videos || [];
    const realIndex = resolveParentIndex(parentArr, video, [videoId, extId], fallback);
    const indexForParent = realIndex >= 0 ? realIndex : visibleIndex;
    this.props.onEdit && this.props.onEdit(indexForParent, video);
  };

  /* ---------- Tarjeta de vídeo (misma estructura que vista pública) ---------- */
  renderItem = (video, idx, { over }) => {
    const src =
      video?.src ||
      video?.fileUrl ||
      (video?.videoUuid ? mfmOriginalUrl(video.videoUuid) : "") ||
      video?.url ||
      "";

    return (
      <div
        className={`vs-card clickable ${over ? "is-over" : ""}`}
        onClick={() => this.handleEditClick(idx, video)}
        title={`Orden ${video?.sortOrder || idx + 1}`}
      >
        {/* Miniatura 16:9 con ReactPlayer */}
        <div className="vs-thumb-16x9">
          <TeaserVideoPlayer
            src={src}
            teaserConfigJson={video?.teaserConfigJson || null}
            controls
            width="100%"
            height="100%"
            className="vs-player"
          />
        </div>

        {/* Info: título + descripción (altura fija) */}
        <div className="vs-card-info">
          <div className="vs-title-text">{video?.title || "\u00A0"}</div>
          {video?.description && (
            <div className="vs-desc-text">{video.description}</div>
          )}
        </div>

        {/* Label "Editar" sutil abajo a la derecha */}
        <span className="vs-edit-label">Editar</span>
      </div>
    );
  };

  render() {
    const { videos, onCreate } = this.props;

    return (
      <section className="videos-section section-block">
        <h3 className="project-subtitle">Vídeos</h3>

        {/* DnD controlado y reindexado por DragSortableList */}
        <DragSortableList
          items={videos}
          orderProp="sortOrder"
          getKey={(item, idx) => getStableKey(item, idx, [videoId, extId])}
          renderItem={this.renderItem}
          onChange={this.handleReorder}
        />

        {/* Botón “Añadir vídeo” con tile estándar */}
        <div className="section-add-tile" onClick={() => onCreate && onCreate()}>
          <span className="section-add-plus">＋</span>
          <span>Añadir vídeo</span>
        </div>
      </section>
    );
  }
}
